import styled from 'styled-components';
import { Button } from '@pearsontechnology/aero-components';

export const InputWrapper = styled.div`
  margin-bottom: 20px;
`;

export const LTIRadioWrapper = styled.div`
  display: flex;
`;

export const LTIShowHideButton = styled(Button)`
  margin-left: 16px;
  height: 20px;
`;

export const LTIKeyContainer = styled.div`
`;

export const LTIKeySectionContainer = styled.div`
  margin-top: 16px;
`;

export const LTIKeySectionLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
`;
